import React, { useEffect } from 'react';
import { Icon, TextInput } from '@sabre/spark-react-core';
import { func, number } from 'prop-types';
import { useCorePricingContext } from '../../../contexts/core-pricing-context.jsx';
import { SCREEN_NAMES } from '../../../utils/constants.js';
import { NOTIFICATION_MESSAGES } from '../../../utils/notification-messages.js';
import { toastWarn } from '../../../utils/toasts.js';

const NewDistributionGroup = ({
   distributionGroupNumber,
   setDistributionGroupNumber,
   generateDistributionGroupNumber,
}) => {
   const { setActiveScreen } = useCorePricingContext();

   const handleChange = (_, changedValue) => {
      if (changedValue.length <= 6) {
         setDistributionGroupNumber(changedValue);
      } else {
         toastWarn(NOTIFICATION_MESSAGES.DISTRIBUTION_NUMBER_MAX_LENGTH);
      }
   };

   useEffect(() => {
      const handleKeyDown = (event) => {
         if (
            (event.ctrlKey && event.key === 'g') ||
            (event.ctrlKey && event.key === 'G')
         ) {
            event.preventDefault();
            generateDistributionGroupNumber();
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [generateDistributionGroupNumber]);

   return (
      <div className='new-distribution-group-root-view'>
         <div className='spark-flex align-center gap-4 spark-pad-t-.5 spark-pad-r-1'>
            <div className='spark-bold'>
               <p>Distribution Group</p>
            </div>

            <div>
               <TextInput
                  value={distributionGroupNumber?.toString() || ''}
                  onChange={handleChange}
                  type='number'
               >
                  <Icon
                     name='math-add'
                     size='md'
                     label='Create New Distribution Group'
                     title='Create New Distribution Group'
                     onClick={() => generateDistributionGroupNumber()}
                  />
               </TextInput>
            </div>

            <Icon
               name='resize-max'
               className='spark-pad-t-.5 cursor-pointer'
               size='md'
               style='fill'
               label='Jump to Distribution Group'
               title='Jump to Distribution Group'
               onClick={() => setActiveScreen(SCREEN_NAMES.REFERENCE)}
            />
         </div>
      </div>
   );
};

NewDistributionGroup.propTypes = {
   distributionGroupNumber: number,
   setDistributionGroupNumber: func.isRequired,
   generateDistributionGroupNumber: func.isRequired,
};

export default NewDistributionGroup;
